import { omitBy, isEmpty, isUndefined } from 'lodash';
// import remoteNorm from '@dhsn/host/shared/normalizer';

import remoteNorm from './phone-numbers';

const model = (data: any) => {
    const orgType = data.orgType === 'HEALTHCARE_PROVIDER' ? 'HEALTH_PROVIDER' : data.orgType;

    let isActive: boolean | undefined;

    switch (data.status) {
        case 'ACTIVE':
            isActive = true;
            break;

        case 'INACTIVE':
            isActive = false;
            break;

        default:
            isActive = undefined;
            break;
    }

    return omitBy({
        _id: data._id,
        title: data.title,
        identification: !isEmpty(data.identificationType) ?
            omitBy({
                type: data.identificationType,
                no: data.identificationNumber,
                placeOfIssue: data.identificationPlaceOfIssue,
                expiryDate: data.identificationExpiryDate,
                issueDate: data.identificationIssueDate,
            }, (value) => isUndefined(value)) : undefined,
        fullName: data.fullName,
        image: data.logoBase64String ? data.logoBase64String : undefined,
        phones: !isEmpty(data.phones) ? (
            data.phones.map((phone: any) => { return remoteNorm(phone) })) : [],
        emails: data.emails,
        addresses: !isEmpty(data.addresses) ?
            data.addresses.map((address: any) => omitBy({
                type: address.type,
                street1: address.street1,
                street2: address.street2,
                city: address.city,
                state: address.state,
                postcode: address.postcode,
                country: address.country,
            }, (value) => isUndefined(value) || value == '')) : [],
        primaryEmail: data.primaryEmail,
        primaryAddress: data.primaryAddress.street1 ? omitBy({
            type: 'OFFICE',
            street1: data.primaryAddress.street1,
            street2: data.primaryAddress.street2,
            city: data.primaryAddress.city,
            state: data.primaryAddress.state,
            postcode: data.primaryAddress.postcode,
            country: data.primaryAddress.country,
        }, (value) => isUndefined(value)) : undefined,
        primaryPhone: !isEmpty(data.primaryPhone) && data.primaryPhone.number
            ? remoteNorm({ ...data.primaryPhone, type: 'MOBILE' }) : undefined,
        dob: data.dob,
        gender: data.gender,
        orgID: data.orgID,
        orgType: orgType,
        onlyActive: isActive,
    }, (value) => isUndefined(value));
}

export default model;
